import axios from '@axios'
import config from '@core/app-config/api-config'

const base = `${config.host}/payment-admin`

/** Empty filters must not reach the API: it validates what it gets, and '' is not a valid status or type */
const clean = params => Object.fromEntries(
  Object.entries(params || {}).filter(([, value]) => value !== '' && value !== null && value !== undefined),
)

const paymentAdminApi = {
  search(params) {
    return axios.get(`${base}/payments`, { params: clean(params) })
  },
  getPayment(id, live = false) {
    return axios.get(`${base}/payments/${id}`, { params: live ? { live: true } : {} })
  },
  problemsSummary(params) {
    return axios.get(`${base}/problems/summary`, { params: clean(params) })
  },
  problems(params) {
    return axios.get(`${base}/problems`, { params: clean(params) })
  },
  events(params) {
    return axios.get(`${base}/events`, { params: clean(params) })
  },
  recheck(id) {
    return axios.post(`${base}/payments/${id}/recheck`)
  },
  linkEntity(id, payload) {
    return axios.post(`${base}/payments/${id}/link-entity`, payload)
  },
  reapply(id) {
    return axios.post(`${base}/payments/${id}/reapply`)
  },
  sweep(limit) {
    return axios.post(`${base}/problems/sweep`, limit ? { limit } : {})
  },
}

export default paymentAdminApi
